import {noop, TextColor} from '@priority-software/priority-style-react';
import {TVoidFunction} from '../../../../types';
import {texts} from '../../../../texts';

export enum ContextMenuTextColor {
    black = 'primary-700',
    red = 'red'
}

export type ContextArrayType = {
    name: string;
    shortCode?: string;
    onClick: () => void;
    subMenu?: ContextArrayType;
    color?: TextColor;
    divider?: boolean;
}[];

export const FilledFieldContextMenu = ({
    handleCopy = noop,
    handlePaste = noop,
    handleCut = noop
}: {
    handleCopy: TVoidFunction;
    handlePaste: TVoidFunction;
    handleCut: TVoidFunction;
}): ContextArrayType => {
    const strings = {
        copy: parseTextSafely(texts.copy_btn_title),
        cut: parseTextSafely(texts.cut_btn_title),
        paste: parseTextSafely(texts.paste_btn_title)
    };
    return [
        {
            name: strings.copy.name,
            shortCode: strings.copy.shortCode,
            onClick: handleCopy
        },
        {
            name: strings.cut.name,
            shortCode: strings.cut.shortCode,
            onClick: handleCut
        },
        {
            name: strings.paste.name,
            shortCode: strings.paste.shortCode,
            onClick: handlePaste
        }
    ];
};

function parseTextSafely(value?: string) {
    if (!value) {
        return {name: '', shortCode: ''};
    }
    const [name = '', shortCode = ''] = value.split(' ');
    return {name, shortCode};
}
